// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { dealerInformationStyles } from "@sc/Overrides/Widgets/DealerDetails/DealerInformation";
import { css } from "styled-components";

dealerInformationStyles.nameGridItem = {
    width: 12,
    css: css`
        padding-left: 5px;
    `,
};

dealerInformationStyles.htmlContentGridItem = {
    width: 12,
    css: css`
        padding-left: 5px;
    `,
};

dealerInformationStyles.addressInfoCondensed = {
    wrapper: {
        css: css`
            padding-left: 0;
            font-style: normal;
        `,
    },
};

dealerInformationStyles.phoneLink = {
    typographyProps: {
        size: 16,
        weight: "normal",
        css: css`
            padding-left: 0;
        `,
    },
};

dealerInformationStyles.addressInfoGridItem = {
    width: 12,
    css: css`
        padding-bottom: 0;
    `,
};

dealerInformationStyles.phoneGridItem = {
    width: 12,
    css: css`
        padding-top: 0;
    `,
};
